import { Component, OnInit } from '@angular/core';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { NavController, } from '@ionic/angular';
import { ModalController, NavParams } from '@ionic/angular';
import { Keyboard } from '@capacitor/keyboard';
import * as moment from 'moment';

import { Constants } from '../../../../providers/constants/constants';
import { ToolsService } from './../../../service/tools/tools.service';
import { LoadingService } from './../../../service/loading/loading.service';
import { AppointmentService } from './../../../service/appointment/appointment.service';
import { VehiculosService } from './../../../service/vehiculos/vehiculos.service';

@Component({
    selector: 'app-cancelappointment',
    templateUrl: './cancelappointment.page.html',
    styleUrls: ['./cancelappointment.page.scss'],
    standalone: false
})
export class CancelappointmentPage implements OnInit {
  constants = Constants;
  idUserSesion = JSON.parse(localStorage.getItem(this.constants.localStorage.user))._id;
  nameCustomer: string;
  lastNameCustomer: string;
  nameAttendAppointment: string;
  lastNameAttendAppointment: string;
  nameCreatorAppointment: string;
  lastCreatorAppointment: string;
  noteAppointment: string;
  typeOfAppointment: string;
  idAppointmentCancel: number;
  dateAppointment: string;
  validations_form: FormGroup;
  titleForm: String = this.constants.cancelarCitas.titleCita;
  detallerForm: String = this.constants.cancelarCitas.detalleCita;
  tipoServicioEsTalle: boolean = this.toolsService.getTipoServicioOrganizacion('serv_taller');

  constructor(
    private modalController: ModalController,
    private navParams: NavParams,
    public navController: NavController,
    public formBuilder: FormBuilder,
    // Capacitor Keyboard API usada de forma estática
    public toolsService: ToolsService,
    public loading: LoadingService,
    public appointmentService: AppointmentService,
    public vehiculosService: VehiculosService,
  ) { }

  ngOnInit() {
    this.validatorsFormCancelAppointment();
    this.nameCustomer = this.navParams.data.paramUser.usuario.nombres;
    this.lastNameCustomer = this.navParams.data.paramUser.usuario.apellidos;
    this.nameAttendAppointment = this.navParams.data.paramUser.citas.usuario_atendedor.nombres;
    this.lastNameAttendAppointment = this.navParams.data.paramUser.citas.usuario_atendedor.apellidos;
    this.nameCreatorAppointment = this.navParams.data.paramUser.citas.usuario_agendador.nombres;
    this.lastCreatorAppointment = this.navParams.data.paramUser.citas.usuario_agendador.apellidos;
    this.noteAppointment = this.navParams.data.paramUser.citas.nota;
    this.typeOfAppointment = this.navParams.data.paramUser.citas.tipos.nombre;
    this.idAppointmentCancel = this.navParams.data.paramUser.citas._id;

    const horaFin = (this.navParams.data.paramUser.citas.fecha_fin) ? ` a ${moment(this.navParams.data.paramUser.citas.fecha_fin).format('h:mm A')}` : '';
    this.dateAppointment = `${this.toolsService.parseDates(this.navParams.data.paramUser.citas.fecha, 1)} ${horaFin}`;
    // para identifica el tipo de empresa en sesion y cambiar el nombre de los labels
    if (this.tipoServicioEsTalle) {
      this.titleForm = this.constants.cancelarCitas.titleServicio;
      this.detallerForm = this.constants.cancelarCitas.detalleServicio;
    }
  }

  validatorsFormCancelAppointment() {
    this.validations_form = this.formBuilder.group({
      descriptionCancelAppointment: ['', [Validators.required]]
    });
  }

  async closeModal(refresh) {
    await this.modalController.dismiss(refresh);
  }

  /**
 * @description Se hace llamado al web services que cancela la cita
 */
  cancelAppointment() {
    const data = { 'nota': this.toolsService.sanitizeInputString(this.validations_form.get('descriptionCancelAppointment').value) };
    Keyboard.hide();
    const mensajeLoading =  this.tipoServicioEsTalle ? this.constants.loading.messages.cancelServicioAppointment : this.constants.loading.messages.cancelAppointment; 
    this.loading.present(mensajeLoading, this.constants.loading.spinner);
    if(this.tipoServicioEsTalle){
      this.cancelarServicio();
    }else{
      this.cancelarCita(data);
    }
  }

  /**
   * @description cancela las cita (servicio taller) para las cuentas a donde el tipo de servicio es tipo taller
   */
  cancelarServicio(){
    const dataServicio = { citas: this.idAppointmentCancel, vehiculos: this.navParams.data.paramUser.vehiculo._id, estados: 'cancelada', nota: this.toolsService.sanitizeInputString(this.validations_form.get('descriptionCancelAppointment').value) };
    this.vehiculosService.postIniciarServicioVehiculo(JSON.stringify(dataServicio))
    .subscribe({
      next: (response: any) => {
        this.loading.dismiss();
        if (response.name === this.constants.services.codeName.G200) {
          this.toolsService.presentToast(this.constants.appointment.notificationCancelServicio);
          this.validations_form.reset();
          this.closeModal(true);
          // this.navController.navigateForward(['/home']);
        }
      },
      error: (err) => {
        this.loading.dismiss();
        this.toolsService.statusService(err);
        this.loading.dismiss();
      }
    });
  }

  /**
   * @description cancela las citas para las cuentas diferentes a donde el tipo de servicio es diferente a taller
   */
  cancelarCita(data: any){
    this.appointmentService.putCancelAppointment(this.idAppointmentCancel, data)
    .subscribe({
      next: (response) => {
        this.loading.dismiss();
        const typeResponse = response['type'];
        if (typeResponse === this.constants.services.types.success) {
          this.toolsService.presentToast(this.constants.appointment.notificationCancel);
          this.validations_form.reset();
          this.closeModal(true);
        } else if (typeResponse === this.constants.services.types.error) {
          this.toolsService.alertErrorInformationWs(response, true, this.constants.contactAgendate.salesTeam.nameKeyTeam);
          setTimeout(() => {
            const mensajeToast =  this.tipoServicioEsTalle ? this.constants.appointment.notificacionServicioSinNotificaciones : this.constants.appointment.notificacionCitaSinNotificaciones; 
            this.toolsService.presentToast(mensajeToast, 7000);
          }, 3000);
        }
      }, error: (err) => {
        this.loading.dismiss();
        this.toolsService.statusService(err);
        this.loading.dismiss();
      }
    });
  }
}
